import { eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@tendly/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateId } from "@fleet/utils";

/**
 * Parents of a Tendly domain attachment. `assetId` may accompany
 * `serviceRecordId`/`warrantyId` so the invoice also appears among the asset's
 * documents.
 */
export interface AttachmentParent {
  assetId?: string | null;
  serviceRecordId?: string | null;
  warrantyId?: string | null;
}

export async function addAttachmentMutation({
  db,
  parent,
  filename,
  url,
  contentType,
  size,
}: {
  db: PowerSyncDrizzleDB;
  parent: AttachmentParent;
  filename: string;
  url: string;
  contentType: string;
  size: number;
}) {
  const id = generateId();
  const now = nowISO();
  await db.insert(attachment).values({
    id,
    asset_id: parent.assetId ?? null,
    service_record_id: parent.serviceRecordId ?? null,
    warranty_id: parent.warrantyId ?? null,
    filename,
    url,
    content_type: contentType,
    size,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function deleteAttachmentMutation(db: PowerSyncDrizzleDB, id: string) {
  await db.delete(attachment).where(eq(attachment.id, id));
}
